import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useMailcoachApplicationsQuery } from "../api/applicationService";

interface Props {
	label: string;
	name: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

export const MailcoachApplicationSelectField: FC<Props> = ({ label, name, ...rest }) => {
	const { data: applications } = useMailcoachApplicationsQuery();

	return (
		<SingleSelectField
			label={label}
			name={name}
			getLabel={(option) => option.subdomain}
			options={applications}
			{...rest}
		/>
	);
};
